<template>
  <div :style="$cmsStyles('c_13c3f481f14e')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_13c3f481f14e', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_13c3f481f14e', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_13c3f481f14e', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_13c3f481f14e', 'f_0004', "Brand Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="desc">{{ $cms('c_13c3f481f14e', 'f_0005', "念都堂根植于东方养生哲学，") }}<br /><br />{{ $cms('c_13c3f481f14e', 'f_0006', "以传统国医精髓“顺应自然、天人合一”为理念、宫廷御养古方为基底，") }}<br /><br />{{ $cms('c_13c3f481f14e', 'f_0007', "结合创新生物技术探索东方草本活性，通过古法今艺重释现代养生之美，实现内外滋养。") }}</div>
            </div>
          </div>

          <div v-show="$cms('c_13c3f481f14e', 'f_0008', true)" class="box-2">
            <div class="box-content">
              <div class="box-left">
                <div class="title-box">
                  <img class="title-icon" :src="$cms('c_13c3f481f14e', 'f_0009', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101319230000944.17557423989151475.png&quot;)" alt="">
                  <div class="title">
                    <div class="title-text">{{ $cms('c_13c3f481f14e', 'f_0010', "品牌故事") }}</div>
                    <div class="title-desc">{{ $cms('c_13c3f481f14e', 'f_0011', "Brand Development") }}</div>
                  </div>
                </div>
                <div class="slogan">{{ $cms('c_13c3f481f14e', 'f_0012', "“穿越三百年的御养古方”") }}</div>
                <div class="desc">{{ $cms('c_13c3f481f14e', 'f_0013', "念都堂深远悠久的历史可追溯至清代康乾年间，史料记载，康熙拥有64位妃子，35子，20女；如此庞大的家族离不开专业健康的保健疗养和卫生医疗体系；这个体系正是皇宫医疗机构——太医院，负责皇帝和嫔妃的医疗保健，专为皇室人员研制养生美食，渐渐地形成了很多宫廷专有的秘制养生保健秘方。") }}<br /><br />{{ $cms('c_13c3f481f14e', 'f_0014', "念都堂正是源自太医院御医后人于1999年在香港初创，后回内陆正式成立商业化品牌；念都堂的取名，也是因创始人长期居住在香港，隔岸思乡；同时感念先人曾在京城首都北京发光发热，因此特取品牌名“念都”来表达自己的思乡之情，也表达先祖智慧源远流传对后人庇佑照拂的感恩之情。") }}</div>
              </div>

              <img class="box-img" :src="$cms('c_13c3f481f14e', 'f_0015', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908164339440000642.17573210191757175.jpg?x-oss-process=image/quality,Q_80&quot;)" alt="">
             
            </div>
          </div>

          <div v-show="$cms('c_13c3f481f14e', 'f_0016', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_13c3f481f14e', 'f_0017', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_13c3f481f14e', 'f_0018', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_13c3f481f14e', 'f_0019', "穿越三百年的御养古方") }}</div>
            </div>
            <div class="box-content">
              <div class="band-group-list">
                <div class="group-item" v-for="item in brandGroupList" :key="item.type">
                  <div class="group-item-list">
                    <div class="item" v-for="listItem in item.list" :key="listItem.name">
                      <div class="item-img">
                        <img :src="listItem.img" loading="lazy" alt="">
                      </div>
                      <div class="item-info">
                        <div class="item-name">{{ listItem.name }}</div>
                        <div class="item-desc">{{ listItem.desc }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_13c3f481f14e', {
    title: '念都堂-东方养生品牌|宫廷御养古方|传统国医精髓|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '念都堂,东方养生,宫廷御养古方,传统国医,养生品牌,草本活性,古法今艺,内外滋养,太医院,御医后人,香港品牌,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '念都堂根植于东方养生哲学，以传统国医精髓"顺应自然、天人合一"为理念，宫廷御养古方为基底，结合创新生物技术探索东方草本活性，通过古法今艺重释现代养生之美，实现内外滋养。',
      },
    ],
  }); },
  data() {
    return {
      brandGroupList: this.$cms('c_13c3f481f14e', 'f_0020', [{"list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163933360000303.17573207731319148.png","name":"香港念都堂·玉灵膏"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163933360000814.17573207731374778.png","name":"香港念都堂·蜂毒筋骨通络贴"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163933360000655.17573207731399824.png","name":"香港念都堂·阿胶燕窝人参膏"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163933360000221.17573207731401934.png","name":"香港念都堂·党参伏湿膏"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908163933360000590.17573207731364274.png","name":"香港念都堂·猴头菇米稀"}]}]),
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_13c3f481f14e-f_0021, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908172439400000696.17573234790332171.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-1 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 598);
        background-image: var(--cms-c_13c3f481f14e-f_0022, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908171451980000863.17573228918012470.png"));
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 190);
        .pxToVw(padding-left, 80);
        .desc {
          .pxToVw(width, 600);
          font-weight: 400;
          .pxToVw(font-size, 24);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }

    .box-2 {
      background: #F8F8F8;
      .pxToVw(padding-top, 80);
      .pxToVw(padding-left, 120);
      .box-content {
        background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
        border-radius: 40px 0 0 40px;
        .pxToVw(padding-left, 120);
        position: relative;
        display: flex;
        justify-content: space-between;
        .box-left {
          .pxToVw(padding-top, 82);
          .title-box {
            display: flex;
            color: #FF6600;
            font-weight: 600;
            .pxToVw(line-height, 40);
            .pxToVw(margin-bottom, 26);
            .title-icon {
              display: block;
              .pxToVw(width, 48);
              .pxToVw(height, 52);
              .pxToVw(margin-right, 14);
            }
            .title-text {
              .pxToVw(font-size, 36);
            }
            .title-desc {
              .pxToVw(font-size, 24);
            }
          }
          .slogan {
            font-weight: 500;
            .pxToVw(font-size, 24);
            .pxToVw(line-height, 33);
            .pxToVw(margin-bottom, 24);
          }
          .desc {
            font-weight: 400;
            .pxToVw(font-size, 18);
            .pxToVw(line-height, 30);
            color: #666666;
            .pxToVw(width, 640);
          }
        }
        .box-img {
          display: block;
          .pxToVw(width, 520);
          .pxToVw(height, 580);
          .pxToVw(margin-right, 240);
          .pxToVw(margin-top, 50);
          .pxToVw(margin-bottom, 50);
        }
      }
    }

    .box-3 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 80);
        .pxToVw(margin-bottom, 80);
        background-image: var(--cms-c_13c3f481f14e-f_0023, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250822103558130000636.17558301578043488.jpg"));
        background-size: cover;
        background-repeat: no-repeat;
        .pxToVw(height, 597);
        .pxToVw(width, 1354);
        position: relative;
        .dot-box {
          position: absolute;
          .dot {
            .pxToVw(width, 30);
            .pxToVw(height, 30);
            background: #FFFFFF;
            box-shadow: 0px 2px 10px 0px rgba(255,102,0,0.4);
            position: relative;
            .pxToVw(border-radius, 30);
            &::after {
              content: "";
              background: #FF6600;
              position: absolute;
              border-radius: 50%;
              .pxToVw(width, 14);
              .pxToVw(height, 14);
              .pxToVw(top, 8);
              .pxToVw(left, 8);
            }
          }
        }
        .item {
          position: absolute;
          .pxToVw(width, 240);
          .info-title {
            font-family: DINCond-Light, DINCond;
            .pxToVw(font-size, 42);
            .pxToVw(line-height, 49);
            color: #FF6600;
            font-weight: bold;
          }
          .info-desc {
            font-weight: 300;
            .pxToVw(font-size, 14);
            .pxToVw(line-height, 30);
            color: #666666;
          }
          &:nth-child(1) {
            .pxToVw(top, 390);
            .pxToVw(left, 20);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(2) {
            .pxToVw(bottom, 286);
            .pxToVw(left, 322);
            .dot-box {
              .pxToVw(bottom, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(3) {
            .pxToVw(top, 345);
            .pxToVw(left, 600);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(4) {
            .pxToVw(bottom, 420);
            .pxToVw(left, 860);
            .dot-box {
              .pxToVw(bottom, -80);
              .pxToVw(left, 30);
            }
          }
          &:nth-child(5) {
            .pxToVw(top, 132);
            .pxToVw(left, 1164);
            .dot-box {
              .pxToVw(top, -50);
              .pxToVw(left, 30);
            }
          }
        }
      }
    }

    .box-4 {
      background: #F8F8F8;
      .pxToVw(padding-top, 80);
      .pxToVw(padding-bottom, 110);
      .pxToVw(padding-right, 240);
      .box-content {
        border-radius: 0px 40px 40px 40px;
        background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
        box-sizing: border-box;
        .pxToVw(height, 680);
        position: relative;
        display: flex;
        .box-right {
          .pxToVw(padding-top, 82);
          .pxToVw(width, 500);
          .title-box {
            display: flex;
            color: #FF6600;
            font-weight: 600;
            .pxToVw(line-height, 40);
            .pxToVw(margin-bottom, 80);
            .title-icon {
              display: block;
              .pxToVw(width, 48);
              .pxToVw(height, 52);
              .pxToVw(margin-right, 14);
            }
            .title-text {
              .pxToVw(font-size, 36);
            }
            .title-desc {
              .pxToVw(font-size, 24);
            }
          }
          .slogan {
            font-weight: 500;
            .pxToVw(font-size, 24);
            .pxToVw(line-height, 33);
            .pxToVw(margin-bottom, 24);
          }
          .desc {
            font-weight: 400;
            .pxToVw(font-size, 18);
            .pxToVw(line-height, 30);
            color: #666666;
          }
        }
        .box-img {
          display: block;
          .pxToVw(width, 667);
          .pxToVw(height, 600);
          .pxToVw(margin-left, 240);
          .pxToVw(margin-right, 104);
          .pxToVw(margin-top, 110);
        }
      }
    }

    .box-7 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);

      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(width, 1440);
        .pxToVw(padding-top, 100);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-title {
          font-weight: 600;
          .pxToVw(font-size, 30);
          .pxToVw(line-height, 42);
          .pxToVw(margin-bottom, 30);
          color: #333333;
        }
        .group-item {
          width: 100%;
        }
        .group-item-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .pxToVw(width, 360);
            .pxToVw(height, 293);
            background: #fbfbfb;
            box-sizing: border-box;
            .item-img {
              .pxToVw(width, 180);
              .pxToVw(height, 180);
              border-radius: 50%;
              background: #FFFFFF;
              // border: 1px solid #CCCCCC;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                display: block;
                border-radius: 50%;
                .pxToVw(width, 180);
                .pxToVw(height, 180);
              }
            }
            .item-name {
              .pxToVw(margin-top, 20);
              font-weight: 600;
              .pxToVw(font-size, 24);
              .pxToVw(line-height, 33);
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
